import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed/use-feature-exposed";

import { Headings } from "../../../components/headings";
import { FreeForTenUsersText } from "../../../components/sub-heading";
import { WelcomeBackText } from "../../../components/welcome-back-heading";

export const LoggedInJiraFreeExistingSitesUser = () => {
    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    <Headings
                        main={<WelcomeBackText />}
                        sub={<FreeForTenUsersText />}
                    />
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
